<script setup lang="ts">
    import CheckboxInput from '@/js/components/CheckboxInput.vue';
    import ActiveFiltersContainer from '@/js/components/filter/ActiveFiltersContainer.vue';
    import AllFilters from '@/js/components/filter/AllFilters.vue';
    import FavoriteFilters from '@/js/components/filter/FavoriteFilters.vue';
    import EchoButton from '@/js/components/EchoButton.vue';
    import ToggleSwitch from '@/js/components/ToggleSwitch.vue';
    import { FilterStoreName } from '@/js/services/api/filter/types';
    import { __ } from '@/js/stores/expressions';
    import {
        InteractionTableStoreName,
        useInteractionTableStoreByName,
    } from '@/js/stores/interactions-table';
    import { ref } from 'vue';
    import { useFilterWatch } from '@/js/composables/useFilterWatch';

    const allFiltersVisible = ref(false);
    const showAddFavoriteModal = ref(false);

    const { filterStore } = useFilterWatch(FilterStoreName.SharedFilter, {
        endpoint: 'protocols/filter',
    });

    const interactionsTableStore = useInteractionTableStoreByName(
        InteractionTableStoreName.ProtocolTable
    );
</script>
<template>
    <div class="flex items-stretch">
        <div class="flex-grow w-0 pt-10">
            <div class="flex items-end">
                <div class="flex flex-grow pt-6">
                    <ActiveFiltersContainer
                        :filter-store-name="FilterStoreName.SharedFilter"
                        match-table-padding
                    >
                        <template #save-filter>
                            <EchoButton
                                variant="primary"
                                size="small"
                                :title="__('favorite-filters-save')"
                                @click="showAddFavoriteModal = true"
                            >
                                {{ __('favorite-filters-save') }}
                            </EchoButton>
                        </template>
                        <template #favorite-filters>
                            <FavoriteFilters
                                v-model:show-add-modal="showAddFavoriteModal"
                                :filter-store-name="FilterStoreName.SharedFilter"
                            />
                        </template>
                    </ActiveFiltersContainer>
                </div>
                <div class="flex items-center gap-10 pb-4 px-7.5">
                    <CheckboxInput
                        v-if="filterStore.all"
                        id="new-events-only"
                        v-model="filterStore.all.isNew"
                        :label="__('protocol-filter-only-my-protocols')"
                    >
                        <p class="text-body">
                            {{ __('protocol-filter-only-new-events') }}
                        </p>
                    </CheckboxInput>
                    <ToggleSwitch
                        v-model="interactionsTableStore.showCoachResultAsPoints"
                        :label="__('protocol-filter-points')"
                        :start-label="__('protocol-filter-percentage')"
                    />
                </div>
            </div>
            <div class="px-7.5 pb-7.5">
                <slot name="table" />
            </div>
        </div>
        <div class="relative">
            <div class="top-0" :class="allFiltersVisible ? 'sticky w-80' : ''">
                <AllFilters
                    :filter-store-name="FilterStoreName.SharedFilter"
                    :is-visible="allFiltersVisible"
                    match-table-padding
                    @toggle-visibility="(visible) => (allFiltersVisible = visible)"
                />
            </div>
        </div>
    </div>
</template>
